import numeral from "numeral"
import * as PLANS from "./subscription-plans"

const Stripe = window.Stripe
if (process.env.NODE_ENV === "development") {
  Stripe.setPublishableKey("pk_test_lxb7hhmRabYsROlQUxwEAWw1")
} else {
  Stripe.setPublishableKey("pk_live_uZphBBhh3PXt06VHdhIdjUjU")
}

export function createToken(form) {
  const { number, cvc, exp_month, exp_year, address_zip } = form
  return new Promise((resolve, reject) => {
    Stripe.card.createToken(
      {
        number,
        cvc,
        exp_month,
        exp_year,
        address_zip,
      },
      (status, response) => {
        if (response.error) {
          reject(response.error.message)
        } else {
          resolve(response.id)
        }
      }
    )
  })
}

export function getPlanById(id) {
  return Object.values(PLANS).find(plan => plan.id === id) || PLANS.FREE_PLAN
}

export function getPriceLabel(plan) {
  return numeral(plan.price / plan.interval / 100).format("$0.00")
}

export function getPlanDescription(plan) {
  const priceLabel = getPriceLabel(plan)
  const intervalLabel = plan.interval === 12 ? " (billed annually)" : ""
  return `Smallchat ${plan.name} for ${priceLabel}/mo${intervalLabel}`
}



// WEBPACK FOOTER //
// ./src/account/billing/utils.js